"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _reactPolyglot = require("react-polyglot");

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _redux = require("../../types/redux");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SortButton = ( /*#__PURE__*/0, _styledBase.default)(_netlifyCmsUiDefault.StyledDropdownButton, {
  target: "e12k9syt0",
  label: "SortButton"
})(_netlifyCmsUiDefault.buttons.button, ";", _netlifyCmsUiDefault.buttons.medium, ";", _netlifyCmsUiDefault.buttons.grayText, ";font-size:14px;&:after{top:11px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function nextSortDirection(direction) {
  switch (direction) {
    case _redux.SortDirection.Ascending:
      return _redux.SortDirection.Descending;

    case _redux.SortDirection.Descending:
      return _redux.SortDirection.None;

    default:
      return _redux.SortDirection.Ascending;
  }
}

function sortIconProps(sortDir) {
  return {
    icon: 'chevron',
    iconDirection: sortIconDirections[sortDir],
    iconSmall: true
  };
}

const sortIconDirections = {
  [_redux.SortDirection.Ascending]: 'up',
  [_redux.SortDirection.Descending]: 'down'
};

const SortControl = ({
  t,
  fields,
  onSortClick,
  sort
}) => {
  return (0, _core.jsx)(_netlifyCmsUiDefault.Dropdown, {
    renderButton: () => (0, _core.jsx)(SortButton, null, t('collection.collectionTop.sortBy')),
    closeOnSelection: false,
    dropdownTopOverlap: "30px",
    dropdownWidth: "160px",
    dropdownPosition: "left"
  }, fields.map(field => {
    const sortDir = sort === null || sort === void 0 ? void 0 : sort.getIn([field.key, 'direction']);
    const isActive = sortDir && sortDir !== _redux.SortDirection.None;
    const nextSortDir = nextSortDirection(sortDir);
    return (0, _core.jsx)(_netlifyCmsUiDefault.DropdownItem, _extends({
      key: field.key,
      label: field.label,
      onClick: () => onSortClick(field.key, nextSortDir),
      isActive: isActive
    }, isActive && sortIconProps(sortDir)));
  }));
};

var _default = (0, _reactPolyglot.translate)()(SortControl);

exports.default = _default;